import styled from 'styled-components';

export default styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5%;
  position: relative;
  .bg-image {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
  > div {
    flex: 1;
    z-index: 1;
  }
  .ecrcs-left {
    display: flex;
    justify-content: center;
    align-content: center;
    img {
      width: 100%;
    }
  }
  .ecrcs-right {
    max-width: 800px;
    padding: 3%;
    button {
      outline: none;
      border: none;
    }
  }
`;
